export const COMMON = {
  NAME: '名称',
  BTN_SEARCH: '実行',
  DELETE: '削除',
  ACTION: '削除',
  STATUS_OPEN: 'オープン',
  STATUS_IN_PROGRESS: '進行中',
  STATUS_CLOSE: 'クローズ',
  START_DATE: '開始日',
  END_DATE: '終了日',
  BTN_IMPORT: '取込',
  BTN_CANCEL: 'キャンセル',
  REGISTER: '登録',
  REGISTER_PRODUCT_MASTER: '製品マスタ取込',
  BTN_SAVE: '保存',
  BTN_CREATE: '作成',
  BTN_DELETE: '削除',
  BTN_CLEAR: 'クリア',
  BTN_EXECUTION: '実行',
  BTN_CREATE_IMPORT: '新規作成',
  BTN_CHOOSE_NITTOKU_CODE: '選択',
  BTN_OK: 'OK',
  BTN_CLOSE: '閉じる',
};

export const LOGIN = {
  TITLE: 'ログイン',
  EMAIL: 'Eメール',
  PASSWORD: 'パスワード',
  REMEMBER: 'サインイン情報を記憶する',
  FORGOT_PASSWORD: 'パスワード忘れ？',
  LOGIN: 'ログイン',
  GREETING: '管理者さん、こんにちは',
  SEND_EMAIL: 'リカバリメールを送信する',
  CAN_REMEMBER: 'パスワードを覚えますか？',
  BACK_TO_LOGIN: 'ログインしてみてください',
  NEW_PASSWORD: '新しいパスワード',
  CONFIRM_PASSWORD: '新しいパスワード確認',
  RESET_PASSWORD: 'パスワードリセット',
  SETTING: '設定',
  LOGOUT: 'ログアウト',
  BACK_TO_LOGIN_FORGOT: 'パスワード忘れ画面に戻る',
  PLEASE_SEND_EMAIL: '秒後にもう一度お試しください',
};
export const PRODUCT = {
  TITLE_LIST: '製品マスタリスト',
  TITLE_EDIT: 'マスタ修正',
  TITLE_ADD: '新規マスタ登録',
  TAB_HISTORY: '変更履歴',
  BTN_IMPORT: 'マスタ取込',
  BTN_EDIT_IMPORT: 'マスター修正取込',
  BTN_EXPORT: '出力',
  PACKAGING_CODE: '包装コード',
  NUMBER_PRODUCT: '品番',
  STOCK_NO: 'ストックＮｏ. ',
  NO: 'NO',
  NAME_PRODUCT: '製品名',
  QUANTITY_PRODUCT: '仕掛品',
  CURRENT_STOCK_INVENTORY_QUANTITY: '在庫',
  ESTIMATED_INVENTORY_QUANTITY: '納品予定残',
  ACTION: 'アクション',
  NITTOKU_CODE: '日特コード',
  PACKAGING_ITEM_CODE: '包装品目コード',
  NUMBER: '号数',
  NAME_NIHON_SHIKO: '日本紙工名称',
  NIPPON_SHIKO: '日本紙工',
  NAME_NITTOKU: '日特名称',
  TERMINAL: '端子',
  SIZE_CLASSIFICATION: '大小区分',
  SIZE_NITTO: '大小（日特）',
  DESIGN_NO: 'デザインＮｏ. ',
  PRODUCT_PRICE: '製品単価',
  WORK_PROCESS_PRICE: '仕掛品単価',
  SHELF_NO: '棚番',
  QUANTITY: '入数',
  NOTE_1: '備考１',
  NOTE_2: '備考２',
  NOTE_3: '備考３',
  DATE_CREATE: '作成日',
  USER: 'ユーザー',
  IMPORT: 'マスタ取込',
  UPDATE_IMPORT: 'マスター修正取込',
  TXT_PRODUCT: '製品',
  PROCESS: '工程',
  ORDER_NUMBER: '発注番号',
  STOCK_QUANTITY: '在庫数',
  BTN_EDIT: '手配数入力',
  BTN_RIGHT_N1: '1件ずつ登録',
  BTN_RIGHT_N2: 'CSVで一括登録',
  TXT_SHIPPING_MANAGEMENT: '---- 納品管理 ----',
  DELIVERY: '納品',
  DELIVERY_SCHEDULE: '納品予定残',
  ORDER_NUMBER_STATUS: '状態',
  MODAL_CONFIRM_MESSENGER_EDIT: '編集内容を保存されていない可能性があります。このまま編集画面を離れますか。',
  MODAL_CONFIRM_MESSENGER_CREATE: '登録内容を保存されていない可能性があります。このまま登録画面を離れますか。',
  SEMI_FINISHED_QUANTITY_TABLE: '仕掛数',
  SEMI_FINISHED_QUANTITY: '仕掛品',
  REAL_INVENTORY: '在庫',
  SCHEDULED_DELIVERY_REMAINING: '納品予定数',
  TABS: {
    EDIT: '商品詳細',
    HISTORY: '履歴',
  },
};

export const MODAL = {
  SAVE: '保存',
  CANCEL: 'キャンセル',
  DELETE: '削除',
  OK: 'OK',
  EXPORT: '出力',
  CLOSE: '閉じる',
  MESSENGER: '実行した変更は保存されない場合があります。続行してもよろしいですか。',
};

export const ORDER = {
  NOTIFICATION_ROUND: {
    FIRST_PRELIMINARY_NOTICE: '1回目',
    SECOND_PRELIMINARY_NOTICE: '2回目',
  },
  TABS: {
    FIRST_PRELIMINARY_NOTICE: '1回目内示',
    SECOND_PRELIMINARY_NOTICE: '2回目内示',
    MASTER_REGISTRATION: '未登録製品',
    ORDER_SPECIFICATION: '製品情報',
    ESTIMATED_STOCK: '手配情報登録',
    SHIPPING: '納品予定',
  },
  ORDER_OVERVIEW: {
    ORDER_NAME: '名称',
    STATUS: '状態',
    UNIT: '単位',
    FACTORY: '工場',
    PACKAGING_MATERIAL_CLASS: '包装材分類',
    TYPE: '種別',
    PROCESS: '工程',
    ORDER_CATEGORY: '発注区分',
    DATE_CREATE: '作成日付',
    ORDER_DESCRIPTION: '発注先',
    ISSUING_PURCHASE_ORDER_NUMBER: `発注番号発行`,
    CANCEL_CHANGE_QUANTITY_ARRANGE: `手配数の変更を取下げる`,
  },
  LIST: {
    TITLE: '手配一覧',
    COLUMN: {
      TOTAL_ITEMS: '内訳数',
      TOTAL_ORDER_NUMBER: '発注数',
      CONDITION: '状態',
      IMPORT_DATE: '取込日',
    },
  },
  CREATE: {
    IMPORT: '内示取込',
    ORDER_DETAILS: '手配詳細 ',
    ORDER_NUMBER: '発注番号',
    CONDITION: '状態',
    QUANTITY_IN_PRODUCTION: '生産中の数量',
    CURRENT_STOCK_QUANTITY: '現在の在庫数量',
    QUANTITY_PRODUCT_ORDER: '注文された製品数量',
    ESTIMATED_STOCK_QUANTITY: '推定在庫数量',
  },
  EDIT: {
    TITLE: '手配変更',
  },
  PRODUCT_ORDER: {
    NITTOKU_CODE: '日特コード',
    STOCK_QUANTITY: '在庫数',
    IN_PROGRESS_FORECAST: '仕掛予測数',
    SCHEDULED_SHIPPING_QUANTITY: '出荷予定数',
    ORDERED_PRODUCT_QUANTITY: '注文された製品数量',
    ARRANGED_QUANTITY: '手配数',
    ESTIMATED_STOCK_QUANTITY_SEARCH: '推定在庫数',
    ESTIMATED_STOCK_QUANTITY_END_MONTH: '推定在庫数\r\n（当月末）',
    ESTIMATED_STOCK_QUANTITY: '推定在庫数\n（手配月末）',
    PRODUCTION_REQUEST: '製造依頼',
    TOTAL_ITEMS: '内示数',
    CHANGE_BEFORE: '変更前',
    CHANGE_AFTER: '変更後',
    NOTE_1: '内示数を変更する日特コードを選択してください',
    NOTE_2: '変更する内示数を入力してください',
    NOTE_3: '(変更前から変更後の内示数へ変更します)',
  },
  SHIPPING_PLAN: {
    NITTOKU_CODE: '日特コード',
    DELIVERY_DATE: '納期',
    TOTAL: '合計',
    DELIVERY_DATE_PLAN: '納品日',
    NUMBER_OF_DELIVERIES: '納品数',
  },
  PRODUCT: {
    NITTOKU_CODE: '日特コード',
    PACKAGING_ITEM_CODE: '包装品目コード',
    STOCK_NO: 'ストックＮｏ. ',
    PRODUCT_NUMBER: '品番',
    NUMBER: '号数',
    NIPPON_PAPER_NAME: '日本紙工名称',
    NITTOKU_NAME: '日特名称',
    PACKAGING_CODE: '包装コード',
    TERMINAL: '端子',
    SIZE_CLASSIFICATION: '大小区分',
    SIZE_NITTOKU: '大小（日特）',
    DESIGN_NO: 'デザインＮｏ.',
    PRODUCT_PRICE: '製品単価',
    WORK_IN_PROGRESS_PRICE: '仕掛品単価',
    QUANTITY: '入数',
    SHELF_NO: '棚番',
    NOTE_1: '備考1',
    NOTE_2: '備考2',
    NOTE_3: '備考3',
    CURRENT_STOCK_QUANTITY: '現在の在庫数量',
    QUANTITY_PRODUCTION: '生産中の数量',
    ESTIMATED_STOCK_QUANTITY: '推定在庫数量',

    PLACEHOLDER: {
      NITTOKU_CODE: '055BCP7E-11R72大',
      PACKAGING_ITEM_CODE: 'RM-9001457-0E8',
      STOCK_NO: '4388-1',
      PRODUCT_NUMBER: 'BCP7E-11',
      NUMBER: '8',
      NIPPON_PAPER_NAME: '北米IX4個11号',
      NITTOKU_NAME: '一般１１号',
      PACKAGING_CODE: '055',
      TERMINAL: 'イフタイ',
      SIZE_CLASSIFICATION: '小箱',
      SIZE_NITTOKU: '大',
      DESIGN_NO: 'R72',
      PRODUCT_PRICE: '8.67',
      WORK_IN_PROGRESS_PRICE: '8.67',
      QUANTITY: '750       ',
      SHELF_NO: '55555',
      NOTE_1: 'オフセット',
      NOTE_2: 'オフセット',
      NOTE_3: 'オフセット',
      CURRENT_STOCK_QUANTITY: '0',
      QUANTITY_PRODUCTION: '0',
      ESTIMATED_STOCK_QUANTITY: '0',
    },
  },
  BUTTON: {
    IMPORT_NAIJI: '内示取込',
    EXPORT_PRODUCT_MASTER: '未登録データ出力',
    IMPORT_PRODUCT_MASTER: '製品マスタ取込',
    ADD_NOTICE: '内示追加',
    CHANGE_INTERNAL_QUOTATION: '内示数変更',
    EXPORT_ORDER: '手配データ',
  },
};

export const PRODUCTION = {
  CREATE: {
    IMPORT: '製造取込',
  },
  LIST: {
    TITLE: '製造管理',
    HISTORY: '製造履歴',
  },
  INVOICE: {
    SHIPMENT_DATE: '出荷日',
    SHIPMENT_QUANTITY: '出荷数',
    FULL_OR_PARTIAL_DELIVERY: '完納・分納',
    PRODUCT_STATUS: '仕掛品・完成品',
  },
  DAILY_WORK_REPORT: {
    WORK_DATE: '作業日',
    SEMI_FINISHED_QUANTITY: '本日製函投入数',
    FINISHED_QUANTITY: '本日製函出来上数',
    SHORTAGE_QUANTITY: 'ロス数',
    COMPLETION_TIME: '完・分',
  },
  SHIPPING: {
    SHIPMENT_DATE: '出荷日',
    SHIPMENT_QUANTITY: '出荷数',
  },
  BUTTON: {
    REGISTER: '1件ずつ登録',
    BULK_REGISTRATION_WITH_CSV: 'CSVで一括登録',
    HISTORY_INFORMATION: '履歴情報',
    DAILY_SCHEDULE: '日計表',
    MANUFACTURING_SHIPPING: '製造出荷',
    INVENTORY_FORM: '棚卸フォーム',
    CANCEL_IMPORT_EXECUTION: 'インポート履歴',
    ACTUAL_INVENTORY: '棚卸取込',
  },
};
export const MODAL_CONFIRM = (value: string) => ({
  DELETE: {
    TITLE: `この出荷(${value})を削除してもよろしいですか?`,
    BUTTON_OK: '削除',
    BUTTON_CANCLE: 'キャンセル',
  },
});

export const CHANGE_PASSWORD = {
  TITLE: 'パスワード変更',
  PASSWORD_CURRENT: '現在のパスワード',
  PASSWORD_NEW: '新しいパスワード',
  PASSWORD_CONFIRM: '新しいパスワード確認',
};

export const HOME = {
  TITLE_PAGE: 'HOME',
  TITLE_CARD: '異常値をアナウンスする',
  NITTO_CODE: '日特コード',
  NUMBER_PRODUCT: '品番',
  PACKAGING_CODE: '包装コード',
  STOCK_NO: 'ストックNO. ',
  DESIGN_NO: 'デザインNo.',
  SIZE_CLASSIFICATION: '大小区分',
  SIZE_NITTO: '大小（日特）',
  CURRENT_STOCK_INVENTORY_QUANTITY: '在庫数',
  DATE_CREATE: '作成日',
  ESTIMATED_INVENTORY: '推定在庫数量（手配月末)',
  MODAL_HOME: {
    ORDER_NUMBER: '発注Ｎｏ',
    NAME_NIHON_SHIKO: '日本紙工名称',
    SIZE_CLASSIFICATION: '大小区分',
    TOTAL_ITEMS: '内示数',
    PROCESS: '工程',
    ESTIMATED_STOCK: '推定在庫数（当月末）',
    ARRANGED_QUANTITY: '手配数',
    ESTIMATED_INVENTORY: '推定在庫数量（手配月末)',
    DELIVERY_DATE: '納期',
  },
};
